// @flow
import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import type {IndiaExportsContext} from 'docs/types';
import {Table, TableHeaderCell, TableCell} from '../../core/Table/Table';

type Props = {|
  entries: $PropertyType<IndiaExportsContext, 'validPurposes'>,
|};

const messages = defineMessages({
  code: {
    id: 'docsApp.components.IndiaExportsTable.headerCells.code',
    description: 'Code',
    defaultMessage: 'Code',
  },
  description: {
    id: 'docsApp.components.IndiaExportsTable.headerCells.description',
    description: 'Description',
    defaultMessage: 'Description',
  },
});

export const IndiaExportsTable = ({entries}: Props) => {
  return (
    <Table type="solid">
      <thead>
        <tr>
          <TableHeaderCell>
            <FormattedMessage {...messages.code} />
          </TableHeaderCell>
          <TableHeaderCell>
            <FormattedMessage {...messages.description} />
          </TableHeaderCell>
        </tr>
      </thead>
      <tbody>
        {entries.map((entry) => (
          <tr key={entry.code}>
            <TableCell>
              <strong>{entry.code}</strong>
            </TableCell>
            <TableCell>{entry.description}</TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
